var waitFor = require('../utils/waitFor');

waitFor('.js-family-table', function() {

  $('.js-family-table').on('mouseenter', 'td, th.th-selectable', function(e) {

    var hoveredCell = e.currentTarget;
    var $currentTable = $(hoveredCell).parents('table');
    var index = $(hoveredCell).index();
    var seriesId = $('.js-family-table th:nth-child(' + (index + 1) + ')').data('series-id');

    if(index == 0)
      return;

    $currentTable.find('tr').each(function() {
      $(this).find('td, th').eq(index).addClass('is-hovered');
    });

    $('#' + seriesId).addClass('is-hovered');


  	$currentTable.find('th:nth-child(' + (index + 1) + ')').addClass('is-hovered');
  });

  $('.js-family-table').on('mouseleave', 'td, th.th-selectable', function(e) {
  	var index = $(e.currentTarget).index();

    var hoveredCell = e.currentTarget;
    var $currentTable = $(hoveredCell).parents('table');
    var index = $(hoveredCell).index();
    var seriesId = $('.js-family-table th:nth-child(' + (index + 1) + ')').data('series-id');

    if(index == 0)
      return;

    $currentTable.find('tr').each(function() {
      $(this).find('td, th').eq(index).removeClass('is-hovered');
    });
  });

  $('.js-family-table').on('click', 'td', function(e) {
    var hoveredCell = e.currentTarget;
    var index = $(hoveredCell).index();

    if(index == 0)
      return;

    e.preventDefault();

    var href = $('.js-family-table th:nth-child(' + (index + 1) + ')').first()
      .find('a').attr('href');

    window.location = href;
  });

});
